import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";

const ChangeNameModal = () => {
  const { setChangeNameModal, changeNameOptions, setChangeNameOptions } = useContext(Context);

  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setChangeNameModal(modalName);
  }, []);

  const handleSetChangeName = (e) => {
    if (e.target.value.length <= 150) {
      setChangeNameOptions((prev) => {
        return { ...prev, name: e.target.value };
      });
    }
  };

  const handleSubmit = ({}) => {
      changeNameOptions.onSubmit(changeNameOptions.name);
      closeButton.current.click();
  }

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="changeNameModal"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="changeNameModal">
              تغییر نام
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <label htmlFor="defaultFormControlInput" className="form-label">
                نام
              </label>
              <input
                type="text"
                className="form-control"
                id="backupName"
                value={changeNameOptions.name}
                onChange={(e) => handleSetChangeName(e)}
                placeholder="نام را وارد کنید"
              />
            </div>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app mb-2"
              data-bs-dismiss="modal"
            >
              انصراف
            </button> */}
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeNameModal;
